import PropTypes from 'prop-types';
import React, {useState} from 'react';
import {Mutation} from 'react-apollo';
import {Col, Row} from 'react-bootstrap';
import {withTranslation} from 'react-i18next';
import {checkErrorType} from '../../utils';
import {validateEmail, validatePassword} from '../../utils';
import {ERROR_TYPE_EMAIL_ALREADY_USED, ERROR_TYPE_PHONE_ALREADY_USED} from '../../common/constants';
import {GRAPHQL_MUTATION_REGISTER_USER} from '../../common/queries/users';
import RegisterStep1 from './RegisterStep1';
import RegisterStep2 from './RegisterStep2';


const RegisterForm = ({t, setIsRegistered}) => {
  const initialUser = {
    civility: 'Mr',
    firstName: '',
    lastName: '',
    email: '',
    birthDate: '',
    password: '',
    postalCode: '',
    mobilePhone: 0,
  };
  const [newUser, setNewUser] = useState(initialUser);
  const [registerError, setError] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [passwordsMatch, setPasswordsMatch] = useState(true);
  const [step, setStep] = useState(1);

  const validateForm = () => {
    return (
      newUser.firstName !== '' &&
      newUser.lastName !== '' &&
      newUser.birthDate !== '' &&
      newUser.email !== '' &&
      newUser.password !== '' &&
      newUser.postalCode !== '' &&
      newUser.mobilePhone !== '' &&
      validateEmail(newUser.email) &&
      passwordsMatch &&
      validatePassword(newUser.password)
    );
  };

  const onSubmit = register => {
    if (validateForm()) {
      register({
        variables: {
          input: newUser,
        },
      });
    }
  };

  return (
    <Mutation
      mutation={GRAPHQL_MUTATION_REGISTER_USER}
      onCompleted={() => setIsRegistered(true)}
      onError={error => {
        if (checkErrorType(error, ERROR_TYPE_EMAIL_ALREADY_USED)) {
          setError(t('reg.existingEmail'));
        } else if (checkErrorType(error, ERROR_TYPE_PHONE_ALREADY_USED)) {
          setError(t('reg.existingPhone'));
        } else {
          setError(t('reg.unknownError'));
        }
      }}>
      {(registerUser) => {
        return (
          <Row>
            <Col xs={{span: 10, offset: 1}} lg={{span: 6, offset: 3}} xl={{span: 4, offset: 4}} className="inputs-block">
              <div className="login-title">{t('reg.form.title')}</div>
              {step === 1 ? (
                <RegisterStep1
                  newUser={newUser}
                  setNewUser={setNewUser}
                  submitted={submitted}
                  setSubmitted={setSubmitted}
                  setStep={setStep}
                  registerError={registerError}
                />
              ) : (
                <RegisterStep2
                  onSubmit={() => onSubmit(registerUser)}
                  passwordsMatch={passwordsMatch}
                  setPasswordsMatch={setPasswordsMatch}
                  setSubmitted={setSubmitted}
                  submitted={submitted}
                  newUser={newUser}
                  setNewUser={setNewUser}
                  registerError={registerError}
                  setError={setError}
                  setStep={setStep}
                />
              )}
            </Col>
          </Row>
        );
      }}

    </Mutation>
  );
};

RegisterForm.propTypes = {
  t: PropTypes.func,
};

export default withTranslation('login')(RegisterForm);
